import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  PreferredOrgChangeProgress,
  PreferredOrgChangeStep
} from '@core/services/preferred-organization-change.service';

/**
 * The four-step progress list of the preferred-organization flows (US 27702),
 * rendered exactly as the wireframe shows it: indeterminate bar on top, then one
 * row per applicable step with a state icon. Step labels are static per step —
 * they do not change between running and done (acceptance criteria).
 */
@Component({
  selector: 'app-preferred-org-progress',
  templateUrl: './preferred-org-progress.component.html',
  styleUrls: ['./preferred-org-progress.component.scss']
})
export class PreferredOrgProgressComponent {

  @Input() progress?: PreferredOrgChangeProgress;
  @Input() showRunInBackground = false;

  @Output() runInBackground = new EventEmitter<void>();

  stepLabelKey(step: PreferredOrgChangeStep): string {
    switch (step.id) {
      case 'sync': return 'preferredOrg.steps.sync';
      case 'clear': return this.progress?.oldName ? 'preferredOrg.steps.clear' : 'preferredOrg.steps.clearGeneric';
      case 'download': return 'preferredOrg.steps.download';
      default: return 'preferredOrg.steps.setDefault';
    }
  }

  stepIcon(step: PreferredOrgChangeStep): string {
    switch (step.status) {
      case 'done': return 'check_circle';
      case 'running': return 'sync';
      case 'failed': return 'error';
      default: return 'schedule';
    }
  }
}
